export const GAME_TITLE = process.env.REACT_APP_GAME_NAME!

export const WIN_MESSAGES = ['Bra jobba!', 'Fantastisk!', 'Utrolig!']
export const GAME_COPIED_MESSAGE = 'Spill kopiert til utklippstavle'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Ikke nok bokstaver'
export const WORD_NOT_FOUND_MESSAGE = 'Ordet er ikke i ordlista'
export const HARD_MODE_ALERT_MESSAGE =
  'Hard Mode kan bare velges før du begynner spillet!'
export const HARD_MODE_DESCRIPTION =
  'Alle hint må brukes ved neste gjetning'
export const HIGH_CONTRAST_MODE_DESCRIPTION = 'Forbedret fargeskille'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `Ordet var ${solution}`
export const WRONG_SPOT_MESSAGE = (guess: string, position: number) =>
  `Du må bruke ${guess} på plass ${position}`
export const NOT_CONTAINED_MESSAGE = (letter: string) =>
  `Gjetningen må inneholde ${letter}`
export const ENTER_TEXT = 'Enter'
export const DELETE_TEXT = 'Slett'
export const STATISTICS_TITLE = 'Statistikk'
export const GUESS_DISTRIBUTION_TEXT = 'Distribusjon av gjetting'
export const NEW_WORD_TEXT = 'Nytt ord om'
export const SHARE_TEXT = 'Del'
export const TOTAL_TRIES_TEXT = 'Totalt antall forsøk'
export const SUCCESS_RATE_TEXT = 'Suksess rate'
export const CURRENT_STREAK_TEXT = 'Nåværende streak'
export const BEST_STREAK_TEXT = 'Beste streak'
